import { seriesMap, scatterMap, hotMap, lineMap, timeMap } from './components';
export default {
  name: 'mapChart',
  components: {
    seriesMap,
    scatterMap,
    hotMap,
    lineMap,
    timeMap
  },
  data() {
    return {};
  }
};